import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import IotStatusSensorReportReportDataroomMaintenenceReport from "./iot-status-sensor-report";
import IotStatusGatewayReportReportDataroomMaintenenceReport from "./iot-status-gateway-report";

const IotStatusReportReportDataroomMaintenenceReport = () => {
    const { t } = useTranslation();
    const types = [{code:"g",title:"GW"}, {code:"s",title:t('message.common.select.sensor')}];
    const [searchTypeCode, setSearchTypeCode] = useState({code:"g",title:"GW"});
    const [isContentsView, setIsContentsView] = useState([false,false]);

    useEffect(()=>{
        if (searchTypeCode === null || searchTypeCode === '') {
            setIsContentsView([false,false]);
            return;
        } else {
            if (searchTypeCode.code === 'g') {
                setIsContentsView([true,false]);
            } else if (searchTypeCode.code === 's') {
                setIsContentsView([false,true]);
            }
        }
    },[searchTypeCode])

    return (
        <div style={{color:"#000"}}>
            <div className="report-dataroom">
                <div className="report-dataroom-left">
                    <ul>
                        <li>{t('message.common.select.division')}</li>
                        {types && types.map(function(param,i) {
                            let boldStyle = "";
                            if (param.code === searchTypeCode.code)
                                boldStyle = "bold";
                            return (
                        <li key={i} style={{fontWeight:`${boldStyle}`}}><Link onClick={()=>{setSearchTypeCode(param)}}>{param.title}</Link></li>        
                            )
                        })}
                    </ul>
                </div>

                <div className="report-dataroom-right">
                    {isContentsView[0] && <IotStatusGatewayReportReportDataroomMaintenenceReport />}
                    {isContentsView[1] && <IotStatusSensorReportReportDataroomMaintenenceReport />}
                </div>
            </div>
        </div>
    )
}

export default IotStatusReportReportDataroomMaintenenceReport;